function closestStore() {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(item => {
      const closestMarker = mapMarkers.reduce((prev, curr) => {
        let geoLocation = new google.maps.LatLng(item.latitude, item.longitude);
        let prevLocation = new google.maps.LatLng(prev.location);
        let curLocation = new google.maps.LatLng(curr.location);

        let currentPos = google.maps.geometry.spherical.computeDistanceBetween(geoLocation, curLocation);
        let prevPos = google.maps.geometry.spherical.computeDistanceBetween(geoLocation, prevLocation);

        return currentPos < prevPos ? curr : prev;
      });
      populateContent(closestMarker);
    });
  }
}

function populateContent(closestMarker) {
  const $currentLocation = $(".search-stores .current-location");
  const $phone = $(`<a href="tel:${closestMarker.phone}">${closestMarker.phone}</a>`);
  const $email = $(`<a href="mailto:${closestMarker.email}">${closestMarker.email}</a>`);

  $currentLocation.show();
  $currentLocation.find("h3").text(`Akris ${closestMarker.state_country}`);
  $currentLocation.find(".address").text(closestMarker.address);
  $currentLocation.find(".phone a").html($phone);
  $currentLocation.find(".hours").html(closestMarker.hours);
  $currentLocation.find(".email").html($email);

  $(".enable-geocoding").show();
  $(".disable-geocoding").hide();
}

module.exports = {
  closestStore
};



// WEBPACK FOOTER //
// ../assets/js/map/closest-store.js